import { Injectable } from '@angular/core';

import { ConfigParserService } from '../shared/services/config-parser.service';

export interface SharePointConfig {
    forceSharePointRefresh: boolean;
    maxInitialSharePointSites: number;
    maxTotalSharePointSites: number;
    sharePointServiceRoot: string;
    sharePointUrl: string;
    showFollowingFirst: boolean;
    resources: SharePointResources;
}

export interface SharePointResources {
    descriptiveAriaLabelTitle: string;
    descriptiveAriaLabelLastVisited: string;
    goToSharePoint: string;
    openSharePointAriaLabel: string;
    sharePointFrequentSitesSectionTitle: string;
    sharePointFollowingSectionTitleLowercase: string;
    sharePointGroupLabel: string;
    sharePointSectionTitleShort: string;
    sharePointZeroFollowingExperienceTitle: string;
    sharePointZeroFollowingExperienceSubtitle: string;
    showMoreSharePointSitesAriaLabel: string;
    showLessSharePointSitesAriaLabel: string;
}

@Injectable({
    providedIn: 'root'
})
export class SharePointConfigService {
    public readonly config: SharePointConfig;

    constructor(configParserService: ConfigParserService) {
        this.config = configParserService.parse<SharePointConfig>('sharePointConfig');
    }
}
